let cachedMatherSegments = null;
export class MatherSegmentsQualifier {
    constructor() {
        this.key = "MatherSegments";
    }
    process() {
        try {
            const stored = localStorage.getItem("_matherSegments");
            cachedMatherSegments = stored !== null && stored !== void 0 ? stored : "";
        }
        catch (_a) {
            cachedMatherSegments = "";
        }
        return cachedMatherSegments;
    }
}
